import lang from "@/views/modules/Reminders/language/en";

import Datepicker from 'vuejs-datepicker';

export default {
    name: "edit-reminder",
    components: {
        Datepicker
    },
    data() {
        return {
            loading: true,
            reminder: {
                users: []
            },
            lang: [],
            usersList: [],
        }
    },
    mounted() {
        this.getReminder();
        this.getUserList();
        this.lang = lang;
    },
    computed: {
        hours() {
            return Array.from({ length: 12 }, (_, index) => (index + 1).toString().padStart(2, '0'));
        },
        minutes() {
            return Array.from({ length: 60 }, (_, minute) => minute.toString().padStart(2, '0'));
        }
    },
    methods: {
        saveReminder() {
            const errorMessages = document.getElementsByClassName('error-message');
            while (errorMessages.length > 0) {
                errorMessages[0].remove();
            }

            const self = this;
            self.loading = true;
            self.reminder.reminder_time = self.formatTime(self.reminder.hours, self.reminder.minutes, self.reminder.period);

            axios.put(`api/modules/reminders/${self.$route.params.id}`, self.reminder).then(function (response) {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data update correctly').toString(),
                    type: 'success'
                });
                self.$router.push('/modules/reminders');
            }).catch(function () {
                self.loading = false;
                let err = localStorage.getItem('Errors');
                let err_msg = (JSON.parse(err));
                let err_msg2 = err_msg.errors;
                Object.keys(err_msg2).forEach((key) => {
                    let errorval = err_msg2[key];
                    const input = document.getElementById(key);
                    const errorDiv = document.createElement('span');
                    errorDiv.className = 'error-message error';
                    errorDiv.textContent = errorval;
                    input.insertAdjacentHTML('afterend', errorDiv.outerHTML);
                });
                localStorage.removeItem('Errors');
            });
        },
        formatTime(hours, minutes, period) {
            let formattedTime = ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2);
            formattedTime += period === 'am' ? 'AM' : 'PM';
            return formattedTime;
        },
        getReminder() {
            const self = this;
            self.loading = true;
             window.currentAction = 'list';
                axios.get('api/modules/reminders/' + self.$route.params.id).then(function (response) {
                self.reminder = response.data;
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
        getUserList() {
            const self = this;
            window.currentAction = 'detail';
            axios.post('api/modules/users/select').then(function (response) {
                self.usersList = response.data.items;
            })
        },
        customFormatter(date) {
            return moment(date).format('DD/MM/yyyy hh:mm:ss a');
        },
        handleReminderTypeChange() {
            if (this.reminder.reminder_type !== 'On Due Date') {
                this.reminder.reminder_date = ''; // Clear the reminder date value
            }

            if (this.reminder.reminder_type !== 'Daily') {
                this.reminder.reminder_time = ''; // Clear the reminder date value
            }
        },
        
    }
}